import { loadCSV } from './csvLoader';

/**
 * Load asset classification data from Asset Classification.csv
 */
export const loadAssetClassificationData = async (forceReload = false) => {
  try {
    // Try loading with URL encoding first, fallback to direct path
    let csvData;
    try {
      csvData = await loadCSV('/Asset%20Classification.csv', forceReload);
      console.log('Loaded Asset Classification.csv with URL encoding');
    } catch (error) {
      // If encoded path fails, try direct path
      console.log('Trying direct path for CSV file...');
      csvData = await loadCSV('/Asset Classification.csv', forceReload);
      console.log('Loaded Asset Classification.csv with direct path');
    }
    
    console.log(`Loaded ${csvData.length} rows from Asset Classification.csv`);
    
    return csvData.map((row, index) => {
      const assetType = (row['Asset Type'] || '').trim();
      const assetSubType = (row['Asset Sub Type'] || '').trim();
      const assetSubTypeCode = (row['Asset Sub Type Code'] || '').trim();
      const model = (row['Model'] || '').trim();
      const make = (row['Make'] || '').trim();
      
      // Generate asset code from model and make, or use index
      // Include index to ensure uniqueness
      let assetCode = '';
      if (model && make) {
        // Use first few letters of make and model
        const makeCode = make.substring(0, 3).toUpperCase().replace(/\s+/g, '');
        const modelCode = model.substring(0, 6).replace(/\s+/g, '').replace(/[^A-Z0-9]/g, '').toUpperCase();
        assetCode = `${makeCode}_${modelCode}_${index}`;
      } else if (model) {
        const modelCode = model.substring(0, 10).replace(/\s+/g, '_').replace(/[^A-Z0-9_]/g, '').toUpperCase();
        assetCode = `${modelCode}_${index}`;
      } else {
        assetCode = `AC_${index}`;
      }
      
      // Combine Make and Model for assetModel field
      const assetModel = make && model ? `${make} ${model}` : (model || make || '');
      
      // Asset Classification is a higher-level category (optional)
      // Can be derived from Asset Type if needed, or left null for user to set
      // For example: "Power Equipment" -> "Equipment", "Vehicles" -> "Vehicle"
      let assetClassification = null;
      if (assetType) {
        // Simple mapping: if Asset Type contains certain keywords, set classification
        const typeLower = assetType.toLowerCase();
        if (typeLower.includes('vehicle') || typeLower.includes('truck') || typeLower.includes('tractor') || typeLower.includes('motorcycle') || typeLower.includes('ambulance')) {
          assetClassification = 'Vehicle';
        } else if (typeLower.includes('equipment') || typeLower.includes('power') || typeLower.includes('generator') || typeLower.includes('ups') || typeLower.includes('battery')) {
          assetClassification = 'Equipment';
        } else if (typeLower.includes('machinery') || typeLower.includes('machine')) {
          assetClassification = 'Machinery';
        } else if (typeLower.includes('electrical') || typeLower.includes('motor') || typeLower.includes('panel')) {
          assetClassification = 'Electrical';
        } else if (typeLower.includes('weighing')) {
          assetClassification = 'Weighing Equipment';
        } else if (typeLower.includes('electronics')) {
          assetClassification = 'Electronics';
        }
      }
      
      return {
        id: `ac_${assetCode}_${index}`,
        assetModel: assetModel || null,
        assetType: assetType || null,
        assetSubType: assetSubType || null,
        assetSubTypeCode: assetSubTypeCode || null,
        assetClassification: assetClassification,
        make: make || null,
        originalData: row
      };
    }).filter(am => am.assetType && am.assetType !== ''); // Filter out rows without Asset Type
  } catch (error) {
    console.error('Error loading asset classification data:', error);
    throw error;
  }
};

